module.exports = __webpack_public_path__ + "media/images/pc/page_common/logo/logo_footer_suns-4f47497ccfde44da228111ce492a7f67.svg";